import { useEffect, useState } from 'react';
import Pages from './pages';
import snapshot from './data/portfolio.json';
import { mergeProjectDetails } from './data/projectDetails';

const prepare = (data) => ({ ...data, projects: mergeProjectDetails(data.projects) });

const PORTFOLIO_URL = 'https://gitconnected.com/v1/portfolio/yarapwnz';

function App() {
  // Render immediately from the bundled snapshot, then refresh from gitconnected.
  // If the API is down or slow, the snapshot stays on screen.
  const [user, setUser] = useState(() => prepare(snapshot));

  useEffect(() => {
    let cancelled = false;
    fetch(PORTFOLIO_URL)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => {
        if (!cancelled && data?.basics) setUser(prepare(data));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return <Pages user={user} />;
}

export default App;
